import { ceil, floor } from "lodash";
import { HydraCollection, HydraView } from "./hydra"

export default class Paginator {

    public totalItems?: number = 0;

    public hasPagination: boolean = false;
    public page?: number = 1;
    public previousPage?: number = null;
    public nextPage?: number = null;

    public firstPage?: number = null;
    public lastPage?: number = null;

    constructor(
        public itemsPerPage: number = 20
    ) {}

    public setItemsPerPage(nb: number) {
        this.itemsPerPage = nb;
    }

    public setPage(nb: number) {
        this.page = nb;
    }

    public update(hydraCollection?: HydraCollection<any>) {
        this.totalItems = hydraCollection["hydra:totalItems"];
        
        if(hydraCollection['hydra:view'] && hydraCollection['hydra:view']['hydra:first']) {
            const firstUrl = new URL(hydraCollection['hydra:view']['hydra:first'], 'https://backyou.io');
            const lastUrl = new URL(hydraCollection['hydra:view']['hydra:last'], 'https://backyou.io');
            const nextUrl = new URL(hydraCollection['hydra:view']['hydra:next'], 'https://backyou.io');
            this.firstPage = parseInt(firstUrl.searchParams.get('page'));
            this.lastPage = parseInt(lastUrl.searchParams.get('page'));
            this.nextPage = parseInt(nextUrl.searchParams.get('page'));
        } else {
            this.firstPage = this.lastPage = 1;
        }

        this.hasPagination = this.lastPage > 1;

        if(this.page > this.lastPage) this.setPage(this.lastPage);
    }
    
    public updateNoAPI(nb_results?: number) {
        this.totalItems = nb_results;

        this.firstPage = 1;
        this.lastPage = floor(nb_results / this.itemsPerPage) + 1;

        if(this.lastPage > 1) {
            this.hasPagination = true;
        }

        if(this.page > this.lastPage) this.setPage(this.lastPage);
    }
}